import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "border-r border-gray-300 h-full w-72 overflow-y-auto" };
const _hoisted_2 = {
    key: 0,
    class: "flex p-2 capitalize font-medium border-b border-gray-200"
};
const _hoisted_3 = { class: "flex-grow items-center justify-center" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-plus" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_folder_card = _resolveComponent("folder-card");
    const _component_create_folder_modal = _resolveComponent("create-folder-modal");
    const _component_confirm_modal = _resolveComponent("confirm-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.create }))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('folder.folders')), 1),
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.showAddCategoryModal && _ctx.showAddCategoryModal(...args))),
                        class: "items-center justify-center cursor-pointer",
                        label: "$t('folder.createNewCategory')"
                    }, _hoisted_5)
                ]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsToShow, (folder, index) => {
                return (_openBlock(), _createBlock(_component_folder_card, {
                    key: folder.id,
                    folder: folder,
                    class: "cursor-pointer relative py-2 border-t-0 border-l-0 border-r-0 border-b",
                    isActive: _ctx.highlightBaseFolder && folder.id === _ctx.activeFolderId,
                    showFileCount: "",
                    onEditCategory: ($event) => (_ctx.showCategoryEditModal(folder)),
                    onRemoveCategory: ($event) => (_ctx.showCategoryDeletionModal(folder)),
                    "show-menu-options": index !== 0 && index !== 1,
                    onClick: ($event) => (_ctx.openFolder(folder)),
                    showBorder: false
                }, null, 8, ["folder", "isActive", "onEditCategory", "onRemoveCategory", "show-menu-options", "onClick"]));
            }), 128))
        ]),
        (_ctx.showAddCategory)
            ? (_openBlock(), _createBlock(_component_create_folder_modal, {
                key: 0,
                show: _ctx.showAddCategory,
                "onUpdate:show": _cache[1] || (_cache[1] = ($event) => ((_ctx.showAddCategory) = $event)),
                category: "",
                categoryToEdit: _ctx.categoryToEdit,
                onUpdateFolder: _ctx.updateFolder
            }, null, 8, ["show", "categoryToEdit", "onUpdateFolder"]))
            : _createCommentVNode("", true),
        (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.delete }))
            ? (_openBlock(), _createBlock(_component_confirm_modal, {
                key: 1,
                show: _ctx.showConfirmDeletion,
                "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((_ctx.showConfirmDeletion) = $event)),
                onConfirm: _ctx.checkContent
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('folder.confirmation', { name: _ctx.translate(`folder.${_ctx.categoryToRemove.name}`, _ctx.categoryToRemove.name) })), 1)
                ]),
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('folder.categoryConfirmationMessage')), 1)
                ]),
                _: 1
            }, 8, ["show", "onConfirm"]))
            : _createCommentVNode("", true),
        (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.delete }))
            ? (_openBlock(), _createBlock(_component_confirm_modal, {
                key: 2,
                show: _ctx.showFolderNotEmpty,
                "onUpdate:show": _cache[3] || (_cache[3] = ($event) => ((_ctx.showFolderNotEmpty) = $event)),
                onConfirm: _ctx.moveToBeClassified,
                onCancel: _cache[4] || (_cache[4] = ($event) => (_ctx.showFolderNotEmpty = false))
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('folder.categoryNotEmpty')), 1)
                ]),
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('folder.moveToClassified')), 1)
                ]),
                ok: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('misc.actions.move')), 1)
                ]),
                cancel: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('misc.cancel')), 1)
                ]),
                _: 1
            }, 8, ["show", "onConfirm"]))
            : _createCommentVNode("", true)
    ], 64));
}
